import { Action } from "../../../actions/actions";
import { VppsActionTypes } from "../actions/actionTypes";

export function subsidiaryList(state: any[] = [], action: Action) {
    switch (action.type) {
        case VppsActionTypes.GET_SUBSIDIARIES_SUCCESS:
            return action.payload.subsidiaries;
        default:
            return state;
    }
}
